<section class="n-profissionais-section">
  @if ($loading() && $profissionais().length > 0) {
  <div class="n-loading-overlay">
    <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
  </div>
  }

  <!-- Botão de Cadastrar Novo Profissional e Campo de Busca -->
  <div class="n-top-section flex flex-column gap-2 mb-2">
    @if (possuiPermissao('Bardo.profissionais.create')) {
      @if ($atingiuLimiteProfissionais()) {
        <div
          class="n-btn-novo-cliente flex align-items-center justify-content-between p-3 opacity-70"
          role="status"
        >
          <div class="flex align-items-center gap-2 text-color-secondary font-medium text-sm sm:text-base">
            <i class="pi pi-lock text-sm"></i>
            <span>{{ $mensagemLimiteProfissionais() }}</span>
          </div>
        </div>
      } @else {
      <div
        class="n-btn-novo-cliente cursor-pointer flex align-items-center justify-content-between p-3"
        (click)="abrirModalView()"
        (keydown.enter)="abrirModalView()"
        role="button"
        tabindex="0"
      >
        <div class="flex align-items-center gap-2 text-primary font-medium text-sm sm:text-base">
          <i class="pi pi-plus text-primary text-sm font-bold"></i>
          <span>{{ 'BARDO_PROFISSIONAIS.CADASTRAR_NOVO' | translate: { termo: $termos().profissional.singular.toLowerCase() } }}</span>
        </div>
        <i class="pi pi-chevron-right text-primary text-xs"></i>
      </div>
      }
    }

    <!-- Campo de Busca -->
    <div class="n-search-box">
      <p-iconfield class="w-full">
        <p-inputicon styleClass="pi pi-search text-primary font-bold" />
        <input
          pInputText
          type="text"
          [ngModel]="pesquisa()"
          (ngModelChange)="pesquisa.set($event)"
          [placeholder]="$termos().profissional.placeholderBusca"
          class="w-full n-input-search"
        />
        @if (pesquisa()) {
          <p-inputicon styleClass="pi pi-times cursor-pointer text-500" (click)="pesquisa.set('')" />
        }
      </p-iconfield>
    </div>
  </div>

  <!-- Contador de Profissionais -->
  <div class="n-counter-header mb-2 flex align-items-center justify-content-between gap-2">
    <span class="text-xs font-bold text-500 uppercase tracking-wider">
      {{ $profissionaisFiltrados().length }} {{ $profissionaisFiltrados().length === 1 ? ($termos().profissional.singular | uppercase) : ($termos().profissional.plural | uppercase) }}
    </span>
    @if ($qtdPausados() > 0) {
      <span class="text-xs text-500">
        {{ 'BARDO_PROFISSIONAIS.ATIVOS_PLANO' | translate: { ativos: $qtdOperacionais(), pausados: $qtdPausados() } }}
      </span>
    }
  </div>

  <!-- Grid de Cards de Profissionais -->
  <div class="n-profissionais-container">
    @if ($loading() && $profissionais().length === 0) {
      <div class="n-skeleton-lista">
        @for (skeleton of skeletonCards; track skeleton) {
          <div class="n-skeleton-item">
            <div class="n-skeleton-avatar"></div>
            <div class="n-skeleton-textos">
              <div class="n-skeleton-linha grande"></div>
              <div class="n-skeleton-linha media"></div>
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="n-profissionais-grid">
        @for (profissional of $profissionaisFiltrados(); track profissional.id) {
          <div
            class="n-professional-card flex flex-column w-full gap-2 p-2 sm:p-3 cursor-pointer"
            [class.pausado]="estaPausado(profissional)"
            (click)="abrirModalView(profissional)"
            role="button"
            tabindex="0"
          >
            <div class="flex w-full items-start justify-content-between gap-2">
            <!-- Conteúdo Principal (Avatar + Informações + Pílulas) -->
            <div class="flex flex-1 items-start gap-2 min-w-0">
              <!-- Avatar -->
              @if (getImagemPerfilUrl(profissional); as imagemUrl) {
                <img
                  class="n-avatar n-avatar-foto border-circle flex-shrink-0"
                  [src]="imagemUrl"
                  [alt]="profissional.nome"
                />
              } @else {
                <div
                  class="n-avatar flex align-items-center justify-content-center text-white font-bold border-circle flex-shrink-0"
                  [style.background-color]="getAvatarColor(profissional.id)"
                >
                  {{ getIniciais(profissional.nome) }}
                </div>
              }

              <!-- Nome e Informações Metadados -->
              <div class="min-w-0 flex-1 flex flex-column gap-1">
                <h3 class="n-item-nome m-0 text-color text-overflow-ellipsis overflow-hidden white-space-nowrap">
                  {{ profissional.nome }}
                </h3>

                <!-- Dias de atendimento -->
                <div class="flex align-items-center gap-1 text-xs text-500 mt-1">
                  <i class="pi pi-calendar text-400 text-xs flex-shrink-0"></i>
                  <span class="text-overflow-ellipsis overflow-hidden white-space-nowrap">{{ getTextoDias(profissional) }}</span>
                </div>

                @if (profissional.descricao) {
                  <p class="m-0 text-xs text-500 text-overflow-ellipsis overflow-hidden white-space-nowrap">
                    {{ profissional.descricao }}
                  </p>
                }

                <!-- Linha de Pílulas (Sempre Inline na mesma linha) -->
                <div class="n-pills-row flex align-items-center gap-1 text-xs text-500 mt-1 min-w-0 max-w-full">
                  @if (profissional.ferias) {
                    <span class="n-pill ferias">
                      <i class="pi pi-calendar-times text-xs"></i> {{ 'BARDO_PROFISSIONAIS.FERIAS' | translate }}
                    </span>
                  }

                  @if (profissional.perfilAcesso) {
                    <span class="n-pill perfil">
                      <i class="pi pi-shield text-xs"></i> {{ perfilLabel(profissional.perfilAcesso) }}
                    </span>
                  }

                  @if (estaPausado(profissional)) {
                    <span class="n-pill pausado">
                      <i class="pi pi-pause text-xs"></i> {{ 'BARDO_PROFISSIONAIS.PAUSADO' | translate }}
                    </span>
                  } @else if (
                    profissional.perfilAcesso === 'PROFISSIONAL' ||
                    !profissional.perfilAcesso
                  ) {
                    <span class="n-pill plano">
                      <i class="pi pi-check text-xs"></i> {{ 'BARDO_PROFISSIONAIS.NO_PLANO' | translate }}
                    </span>
                  }

                  @if (profissional.pessoaId) {
                    <span class="n-pill ativo">
                      <i class="pi pi-check text-xs"></i> {{ 'BARDO_PROFISSIONAIS.LOGIN' | translate }}
                    </span>
                  }
                </div>
              </div>
            </div>

            <div class="n-action-container flex align-items-center gap-1 flex-shrink-0">
              @if (profissional.pessoaId && possuiPermissao('Bardo.profissionais.update')) {
                <p-button
                  icon="pi pi-lock"
                  severity="danger"
                  [text]="true"
                  [rounded]="true"
                  [pTooltip]="'BARDO_PROFISSIONAIS.REVOGAR_LOGIN_TOOLTIP' | translate"
                  tooltipPosition="left"
                  (onClick)="confirmarRevogarAcesso($event, profissional)"
                />
              }
              <div class="n-action-circle flex align-items-center justify-content-center border-circle">
                <i class="pi pi-chevron-right text-400 text-xs"></i>
              </div>
            </div>
            </div>

          @if (estaPausado(profissional) && possuiPermissao('Bardo.profissionais.update')) {
            <button
              type="button"
              class="n-btn-usar-vaga"
              (click)="solicitarReativar(profissional, $event)"
            >
              {{ textoUsarVaga(profissional) }}
            </button>
          }
          </div>
        } @empty {
          @if (!$loading()) {
            @if (pesquisa()) {
              <div class="n-empty-state text-center py-5 text-secondary flex flex-column align-items-center justify-content-center">
                <i class="pi pi-search text-4xl block mb-2 text-400"></i>
                <h3 class="m-0 text-base font-semibold text-700">{{ 'BARDO_PROFISSIONAIS.NENHUM_ENCONTRADO' | translate: { termo: ($termos().profissional.singular | lowercase) } }}</h3>
                <p class="m-0 text-sm text-500 mt-1">{{ 'BARDO_PROFISSIONAIS.NENHUM_RESULTADO_BUSCA' | translate }}</p>
              </div>
            } @else {
              <div class="n-empty-state text-center py-5 text-secondary flex flex-column align-items-center justify-content-center">
                <i class="pi pi-users text-4xl block mb-2 text-400"></i>
                <h3 class="m-0 text-base font-semibold text-700">{{ 'BARDO_PROFISSIONAIS.NENHUM_CADASTRADO' | translate: { termo: ($termos().profissional.singular | lowercase) } }}</h3>
                <p class="m-0 text-sm text-500 mt-1">{{ 'BARDO_PROFISSIONAIS.ADICIONE_PRIMEIRO' | translate: { termo: ($termos().profissional.singular | lowercase) } }}</p>
              </div>
            }
          }
        }
      </div>
    }
  </div>
</section>

<!-- Modal Visualização -->
<lib-profissional-view-modal
  [visible]="modalViewAberto()"
  [profissional]="profissionalSelecionado()"
  (closed)="fecharModalView()"
>
</lib-profissional-view-modal>

<!-- Mobile Bottom Sheet para Confirmar Exclusão de Profissional -->
@if (deviceService.$isMobile() && modalExclusaoAberto()) {
<lib-bottom-sheet
  [visible]="modalExclusaoAberto()"
  (visibleChange)="modalExclusaoAberto.set($event)"
  size="medium"
  [draggable]="true"
  [closeOnBackdrop]="!excluindo()"
  [closeOnEscape]="!excluindo()"
  [preventClose]="excluindo()"
  [headerTemplate]="headerExcluirTemplate"
  [footerTemplate]="footerExcluirTemplate"
  (hide)="modalExclusaoAberto.set(false)"
>
  <div class="flex flex-column align-items-center text-center py-3 px-2 gap-3">
    <div class="w-3rem h-3rem border-circle bg-red-100 flex align-items-center justify-content-center">
      <i class="pi pi-exclamation-triangle text-red-600 text-2xl"></i>
    </div>
    <p class="m-0 text-700 text-base line-height-3" [innerHTML]="'BARDO_PROFISSIONAIS.CONFIRMAR_EXCLUSAO_MSG' | translate: { termo: ($termos().profissional.singular | lowercase), nome: profissionalParaExcluir()?.nome }">
    </p>
  </div>
</lib-bottom-sheet>
}

@if (deviceService.$isMobile() && modalTrocaAberto()) {
<lib-bottom-sheet
  [visible]="modalTrocaAberto()"
  (visibleChange)="modalTrocaAberto.set($event)"
  size="medium"
  [draggable]="true"
  [closeOnBackdrop]="!trocando()"
  [closeOnEscape]="!trocando()"
  [preventClose]="trocando()"
  [headerTemplate]="headerTrocaTemplate"
  [footerTemplate]="footerTrocaTemplate"
  (hide)="fecharModalTroca()"
>
  <ng-container *ngTemplateOutlet="conteudoTroca"></ng-container>
</lib-bottom-sheet>
} @else if (modalTrocaAberto()) {
<p-dialog
  [visible]="modalTrocaAberto()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!trocando()"
  [style]="{ width: '420px', maxWidth: '95vw' }"
  (visibleChange)="onVisibleTrocaChange($event)"
  (onHide)="fecharModalTroca()"
>
  <ng-template pTemplate="header">
    <ng-container *ngTemplateOutlet="headerTrocaTemplate"></ng-container>
  </ng-template>
  <ng-container *ngTemplateOutlet="conteudoTroca"></ng-container>
  <ng-template pTemplate="footer">
    <ng-container *ngTemplateOutlet="footerTrocaTemplate"></ng-container>
  </ng-template>
</p-dialog>
}

<ng-template #conteudoTroca>
  <div class="flex flex-column gap-3 py-2 px-1">
    <p class="m-0 text-700 text-base line-height-3">
      @if (profissionalParaReativar(); as alvo) {
        @if (precisaConverterParaProfissional(alvo)) {
          {{ 'BARDO_PROFISSIONAIS.TROCA_PLANO.MSG_CONVERTER' | translate: { nome: alvo.nome, termo: $termos().profissional.singular } }}
        } @else {
          {{ 'BARDO_PROFISSIONAIS.TROCA_PLANO.MSG_TROCA' | translate: { nome: alvo.nome } }}
        }
        {{ 'BARDO_PROFISSIONAIS.TROCA_PLANO.NINGUEM_APAGADO' | translate }}
      }
    </p>
    <label class="text-sm font-medium text-700" for="pausarProfissional">{{ 'BARDO_PROFISSIONAIS.TROCA_PLANO.QUEM_FICA_PAUSADO' | translate }}</label>
    <p-select
      inputId="pausarProfissional"
      [options]="$candidatosPausar()"
      optionLabel="nome"
      optionValue="id"
      [ngModel]="pausarId()"
      (ngModelChange)="pausarId.set($event)"
      [placeholder]="'BARDO_PROFISSIONAIS.TROCA_PLANO.SELECIONE' | translate"
      styleClass="w-full"
      appendTo="body"
      [disabled]="trocando()"
    />
  </div>
</ng-template>

<ng-template #headerTrocaTemplate>
  <div class="flex align-items-center justify-content-between w-full">
    <h3 class="m-0 font-semibold text-lg">{{ 'BARDO_PROFISSIONAIS.TROCA_PLANO.TITULO' | translate }}</h3>
  </div>
</ng-template>

<ng-template #footerTrocaTemplate>
  <div class="flex gap-2 w-full pt-2">
    <p-button
      [label]="'GLOBAL.CANCELAR' | translate"
      severity="secondary"
      [outlined]="true"
      styleClass="w-full"
      (onClick)="fecharModalTroca()"
      [disabled]="trocando()"
    />
    <p-button
      [label]="'BARDO_PROFISSIONAIS.TROCA_PLANO.CONFIRMAR_TROCA' | translate"
      styleClass="w-full"
      icon="pi pi-replay"
      [loading]="trocando()"
      [disabled]="!pausarId()"
      (onClick)="confirmarTrocaVaga()"
    />
  </div>
</ng-template>


<ng-template #headerExcluirTemplate>
  <div class="flex align-items-center justify-content-between w-full">
    <h3 class="m-0 font-semibold text-lg">{{ 'GLOBAL.CONFIRMAR_EXCLUSAO' | translate }}</h3>
  </div>
</ng-template>

<ng-template #footerExcluirTemplate>
  <div class="flex gap-2 w-full pt-2">
    <p-button
      [label]="'GLOBAL.CANCELAR' | translate"
      severity="secondary"
      [outlined]="true"
      styleClass="w-full"
      (onClick)="modalExclusaoAberto.set(false)"
      [disabled]="excluindo()"
    />
    <p-button
      [label]="'GLOBAL.SIM_EXCLUIR' | translate"
      severity="danger"
      styleClass="w-full"
      icon="pi pi-trash"
      [loading]="excluindo()"
      (onClick)="excluirProfissional(profissionalParaExcluir()?.id)"
    />
  </div>
</ng-template>

<!-- Confirm Dialog -->
<p-confirmDialog></p-confirmDialog>
